import React, { useEffect, useState } from "react";

import { Select, FormLayout, Box } from "@shopify/polaris";

type TimingFieldProps = {
  fields: any;
  period: string;
  paymentType: string;
  advancePaymentCount: number;
  purchaseOptionSegmentFields: Array<any>;
  handlePaymentTypeSelectChange: (selected: string, id: string) => void;
  handleAdvancePaymentCountChange: (selected: string, id: string) => void;
};

const TimingFields = (props: TimingFieldProps) => {
  const {
    fields,
    period = "monthly",
    paymentType = "advance",
    advancePaymentCount = 1,
    purchaseOptionSegmentFields,
    handlePaymentTypeSelectChange,
    handleAdvancePaymentCountChange,
  } = props;

  const paymentTypeOptions = [
    { label: "Advance", value: "advance" },
    { label: "Arrears", value: "arrears" },
  ];
  const periodOptions = [{ label: "Monthly", value: "monthly" }];

  // Generate advance payment count options (1-3)
  const advancePaymentCountOptions = [];
  for (let i = 1; i <= 3; i++) {
    advancePaymentCountOptions.push({
      label: i.toString(),
      value: i.toString(),
    });
  }

  const [lockPaymentType, setLockPaymentType] = useState(false);
  const [optionsForPaymentType, setOptionsForPaymentType] =
    useState(paymentTypeOptions);
  useEffect(() => {
    if (purchaseOptionSegmentFields?.length > 0) {
      let destroyCount = 0;
      for (let i = 0; i < purchaseOptionSegmentFields.length; i++) {
        if (purchaseOptionSegmentFields[i]._destroy.value) destroyCount += 1;
      }

      if (destroyCount == purchaseOptionSegmentFields.length) {
        setOptionsForPaymentType(paymentTypeOptions);
        setLockPaymentType(false);
      } else {
        setOptionsForPaymentType([{ label: "Advance", value: "advance" }]);
        setLockPaymentType(true);
      }
    } else {
      setOptionsForPaymentType(paymentTypeOptions);
      setLockPaymentType(false);
    }
  }, [fields, purchaseOptionSegmentFields]);

  return (
    <FormLayout>
      <FormLayout.Group condensed>
        <div style={{ flex: "1 1 auto", minWidth: "140px" }}>
          <Select label="Period" options={periodOptions} {...fields.period} />
        </div>
        <div style={{ flex: "1 1 auto", minWidth: "140px" }}>
          <Select
            label="Payment Type"
            options={optionsForPaymentType}
            {...fields.payment_type}
            disabled={lockPaymentType}
          />
        </div>
        <div style={{ flex: "0 0 160px", minWidth: "160px" }}>
          <Select
            label="Advance Payment Count"
            options={advancePaymentCountOptions}
            {...fields.advance_payment_count}
            value={
              paymentType === "advance" ? advancePaymentCount.toString() : "1"
            }
            onChange={handleAdvancePaymentCountChange}
            disabled={lockPaymentType || paymentType !== "advance"}
          />
        </div>
      </FormLayout.Group>
    </FormLayout>
  );
};

export default TimingFields;
